import React from 'react';
import { Container, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const NewsNotFound = () => {
    return (
        <Container maxWidth="md" sx={{ py: 12, textAlign: 'center' }} data-ui="state-news-not-found">
            <Typography variant="h4" sx={{ mb: 2, fontWeight: 700 }}>
                Notícia não encontrada
            </Typography>
            <Button 
                component={RouterLink} 
                to="/" 
                variant="outlined" 
                startIcon={<ArrowBackIcon />}
            >
                Voltar para o Início
            </Button>
        </Container>
    );
};

export default NewsNotFound;
